import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'src/App';
import 'src/i18n';
import { AuthContextProvider } from './providers/AuthContextProvider';
import { DebugContextProvider } from './providers/DebugContextProvider';
import { ErrorContextProvider } from './providers/ErrorContextProvider';
import { PriceContextProvider } from './providers/PriceContextProvider';
import { ProductContextProvider } from './providers/ProductContextProvider';
import { StudioContextProvider } from './providers/StudioContextProvider';
import { TrackingContextProvider } from './providers/TrackingContextProvider';
import { UploadContextProvider } from './providers/UploadContextProvider';
import { UploadProvider } from './providers/UploadProvider';
import { ValidationContextProvider } from './providers/ValidationContextProvider';
import { SwanConfiguration } from './SwanConfiguration';

console.log('New build Available');

async function renderApp(): Promise<void> {
  const container = document.getElementById('app');
  if (container) {
    const root = createRoot(container);
    root.render(
      <SwanConfiguration>
        <AuthContextProvider blockUntilAuthenticated>
          <DebugContextProvider>
            <ProductContextProvider>
              <TrackingContextProvider>
                <ErrorContextProvider>
                  <PriceContextProvider>
                    <UploadContextProvider>
                      <ValidationContextProvider>
                        <StudioContextProvider>
                          <UploadProvider>
                            <App />
                          </UploadProvider>
                        </StudioContextProvider>
                      </ValidationContextProvider>
                    </UploadContextProvider>
                  </PriceContextProvider>
                </ErrorContextProvider>
              </TrackingContextProvider>
            </ProductContextProvider>
          </DebugContextProvider>
        </AuthContextProvider>
      </SwanConfiguration>
    );
  } else {
    console.error('Failed to find the app container');
  }
}

renderApp();
